import {
  IInboxPromptContextProps as IContextProps,
  InboxPromptContext,
  InboxPromptProvider,
} from './Provider'

export type IInboxPromptContextProps = IContextProps
export { InboxPromptProvider, InboxPromptContext }
